export default __webpack_public_path__ + "static/media/ferris_wheel.c130b333.svg";